<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';

const STORE_MODULE_NAME = 'AccountNumberModule';

export default {
  name: 'AccountNumberWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
  destroyed() {
    this.persistData();
  },
};
</script>
